import React from 'react';
import './Career.css';

const Career = () => {
  return (
    <div className='career'>
      <div className='career-container'>
        <h1>Career Component</h1>
      </div>
    </div>
  );
};

export default Career;
